import _ from "lodash";
import { ReactElement } from "react";

import { palette } from "~frontend/theme";

import { Chart } from "./Chart";
import { ChartContainer } from "./ChartContainer";
import { Month } from "./monthlyBuckets";
import { maybeNumberToPercentage } from "./numbers";

type Data = {
  month: Month;
  roi?: number;
  firstWeekRoi?: number;
  textsSent?: number;
}[];

export function MonthlyRoisChart({
  data,
}: {
  data: Data | null;
}): ReactElement {
  return (
    <ChartContainer
      title="Monthly ROI"
      loading={!data}
      downloadableRows={data?.map(r => ({
        month: r.month.toString(),
        roi: (r.roi ?? 0).toFixed(4),
        firstWeekRoi: (r.firstWeekRoi ?? 0).toFixed(4),
        textsSent: (r.textsSent ?? 0).toFixed(0),
      }))}
      downloadFileName="monthlyRois.csv"
      empty={data?.length === 0}
    >
      <Chart
        data={data ?? []}
        series={[
          {
            type: "line",
            yAxisId: "roi",
            label: "Full Campaign",
            color: palette.navy,
            getValue: data => data.roi ?? null,
          },
          {
            type: "line",
            yAxisId: "roi",
            label: "First Week",
            color: palette.darkGreen,
            getValue: data => data.firstWeekRoi ?? null,
          },
          {
            type: "bar",
            yAxisId: "messages",
            label: "Total Messages Sent",
            color: palette.blue,
            getValue: data => data.textsSent ?? null,
          },
        ]}
        getXAxisValue={data => data.month.toString()}
        xAxisLabel="Campaign Start Month"
        xAxisTicks={4}
        yAxes={{
          roi: {
            position: "left",
            formatValue: value => maybeNumberToPercentage(value, 2)!,
            formatTick: value => maybeNumberToPercentage(value, 0)!,
            label: "ROI",
            width: 60,
          },
          messages: {
            position: "right",
            label: "Total Messages Sent",
            width: 80,
          },
        }}
        height={280}
      />
    </ChartContainer>
  );
}
